export const enabledStubDetailImageConstructor = false
export const enabledSocialImageConstructor = false
export const availableAspectRatios = [1.96, 1.5, 1, 1.8, 1.9]
